import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const AUDIT_DATA = {
	true: { id: true, name: 'Audited' },
	false: { id: false, name: 'Pending' }
};

const Audit = ({ isDependentFilter }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);

	useEffect(() => {
		onSetData();
	}, [dependentFilterList]);

	const onSetData = () => {
		let response = [];

		if (isDependentFilter && dependentFilterList?.isVisited) {
			dependentFilterList.isVisited.map((item) => response.push(AUDIT_DATA[item]));
		} else {
			response = Object.values(AUDIT_DATA);
		}
		setAllData(response);
		setData(response);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="AUDIT" />
			<Checkbox data={data} type="AUDIT" handleSearch={handleSearch} />
		</>
	);
};

export default Audit;
